<div class="complainForm">
  <ng-container *ngIf="data$ | async as data">
    <h1>{{ data.title }}</h1>
  </ng-container>
  <ng-container *ngIf="data$ | async as data">
    <p>
      <a
        [href]="mediaUrl(mediaUrl$ | async)"
        download=""
        rel="noopener noreffer"
        target="_blank"
        type="application/octet-stream"
        >{{ data.linkName }} <mat-icon class="material-icons-sharp light warranty-icon">system_update_alt</mat-icon></a
      >
    </p>
  </ng-container>
</div>
